import * as yup from "yup";

export const defaultFormValues = {
  name: "",
  code: "",
  makeDefault: false,
  openAiConfig: {
    apiKey: "",
    model: "gpt-3.5-turbo",
  },
  anthropicConfig: {
    anthropicApiKey: "",
    anthropicModel: "claude-haiku-4-5",
  },
  geminiConfig: {
    geminiApiKey: "",
    geminiModel: "gemini-1.5-pro",
  },
  openAiDalleConfig: {
    openAiDalleApiKey: "",
    openAiDalleModel: "dall-e-3",
  },
};

export const schema = yup
  .object({
    name: yup.string().required("Name required"),
    code: yup.string().required("Code required"),
    maleDefault: yup.boolean(),
    openAiConfig: yup.object({
      apiKey: yup.string(),
      model: yup.string(),
    }),
    anthropicConfig: yup.object({
      anthropicApiKey: yup.string(),
      anthropicModel: yup.string(),
    }),
    geminiConfig: yup.object({
      geminiApiKey: yup.string(),
      geminiModel: yup.string(),
    }),
    openAiDalleConfig: yup.object({
      openAiDalleApiKey: yup.string(),
      openAiDalleModel: yup.string(),
    }),
  })
  .test(
    "provider-fields-required",
    "Matching provider config fields are required",
    function (data) {
      if (data.code === "openai") {
        return !!data.openAiConfig.apiKey && !!data.openAiConfig.model;
      }
      if (data.code === "anthropic") {
        return (
          !!data.anthropicConfig.anthropicApiKey &&
          !!data.anthropicConfig.anthropicModel
        );
      }
      if (data.code === "gemini") {
        return (
          !!data.geminiConfig.geminiApiKey && !!data.geminiConfig.geminiModel
        );
      }
      if (data.code === "openai_dalle") {
        return (
          !!data.openAiDalleConfig.openAiDalleApiKey &&
          !!data.openAiDalleConfig.openAiDalleModel
        );
      }
      return true; // if no code is selected
    }
  );
